import React, { useState } from 'react';
import CustomDrawer from '../../controls/CustomDrawer';
import Button from '../../controls/Button';
import Input from '../../controls/Input';
import Select from '../../controls/Select';

const FilterAttendance = ({ setFilterComp, onApplyFilter, onClearFilter, initialFilters }) => {

  const [employee, setEmployee] = useState(initialFilters.employee || "");
  const [fromDate, setFromDate] = useState(initialFilters.fromDate || "");
  const [toDate, setToDate] = useState(initialFilters.toDate || "");
  const [status, setStatus] = useState(initialFilters.status || "all");

  const handleSearchClick = () => {
    onApplyFilter({
      employee: employee || null,
      fromDate: fromDate || null,
      toDate: toDate || null,
      status: status,

    });
    setFilterComp(false);
  };

  const handleClearClick = () => {
    setEmployee("");
    setFromDate("");
    setToDate("");
    setStatus("all");
    onClearFilter();
    setFilterComp(false);
  };

  // Options for the status select

  return (
    <>
      <CustomDrawer
        setDrawer={setFilterComp}
        title="Filter"
        drawerType='small'
        buttons={[
          { Label: "Clear", Type: "secondary", Icon: "roundedRemove" },
          { Label: "Search", Type: "primary", Icon: "search" },
        ]}
        onButtonClick={(label) => {
          if (label === "Search") {
            handleSearchClick();
          } else if (label === "Clear") {
            handleClearClick();
          }
        }}

      >
        <div className='flex flex-col gap-4'>
          <Input
            label="Employee"
            placeholder="enter employee name"
            value={employee}
            onChange={(e) => setEmployee(e.target.value)}


          />
          <Input
            label="From Date"
            type={"date"}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />

          <Input
            label="To Date"
            type={"date"}
            value={toDate}
            onChange={(e)=>{setToDate(e.target.value)}}
          />

          <Select
            label="Status"            
            placeholder="Select" 
              options={[{ label: "All", value: "all" },{ label: "Present", value: "Present" }, { label: "Half Day", value: "Half Day" },
            { label: "Leave", value: "Leave" }, { label: "Week-Off", value: "Week-Off" },]}
            value={status}
            onChange={(e)=>{setStatus(e.target.value)}}
         
          />


        </div>


      </CustomDrawer>
    </>
  );
};

export default FilterAttendance;
